import { BaseFeature, FeatureType } from '@core/shared/feature';
export class AccessibilityBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/accessibility/feature","featureId":"common-accessibility"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'AccessibilityFrontendFeature'
      },
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'AccessibilityFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'AccessibilityFrontendFeature',
        importFrom: 'frontend'
      }
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'AccessibilityBackendFeature'},
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'AccessibilityBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          accessibility: () => '/accessibility-settings'
        }
      }
    };
  }
}